import store from '../store'

export function getLanguage(languages, userLanguageId) {
    const localeQuery = new URL(location).searchParams.get('locale')
    if (localeQuery && !store.getters['common/set_locale_processed']) {
      store.dispatch('common/SET_SET_LOCALE_PROCESSED', true);
      store.dispatch('common/SET_LANGUAGE', [languages.find(
        (l) => l.code.split('-')[0] === localeQuery.split('-')[0]
      ).id]);
      store.dispatch('common/SET_LANGUAGE_CODE', [languages.find(
        (l) => l.code.split('-')[0] === localeQuery.split('-')[0]
      ).code]);
      return languages.find(
        (l) => l.code.split('-')[0] === localeQuery.split('-')[0]
      );
    }
    let languageId = userLanguageId ? userLanguageId : 1
    return languages.find((l) => l.id === languageId);
  }